import IComponent from "components/commons/IComponent";

import Checkbox from "@material-ui/core/Checkbox";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";
import LayerToggleUtil from "utils/LayerToggleUtil";
import "./ItemCard.scoped.css";
import GetArcGISToken from "utils/GetArcGISToken";
import moment from "moment";
import OpacitySlider from "components/LayerSetting/OpacitySlider";

const LAYER_TYPE_OPACITY_SUPPORT = {
  "building-scene": 1,
  // "point-cloud": 1,
  scene: 1,
  feature: 1,
  bim: 1,
};

const DOWNLOAD_SUPPORT = {
  "point-cloud": 1,
  voxel: 1,
};

class ItemCard extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLayerLoaded: false,
      isChecked: false,
      showOperationBox: false,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}

  onCheckboxClick(evt) {
    let isLayerLoaded =
      "layer" in this.props.layerItem && this.props.layerItem?.layer?.visible;
    let categoryItemInConfig = this.$config.mapList.layer3D[this.props.categry];
    if (categoryItemInConfig !== undefined) {
      let layerItemInConfig = categoryItemInConfig.find(
        (item) => item.id === this.props.layerItem.id
      );
      console.log(
        "Itemcard layerItem",
        this.props.layerItem,
        this.props.categry
      );
      LayerToggleUtil.toggle3DLayer(
        this.props.categry,
        this.props.layerItem,
        !isLayerLoaded,
        this.props.mapView,
        false,
        !isLayerLoaded
      );
      this.setState({});
      this.props.on3DLayerChange();
    }
  }

  handleClickThreePoints() {
    this.setState({
      showOperationBox: true,
    });
  }

  onLeaveOperationContainer() {
    this.setState({
      showOperationBox: false,
    });
  }

  onDownloadClick() {
    if (this.props.layerItem.metaData?.downloadUrl) {
      window.open(this.props.layerItem.metaData.downloadUrl, "_blank");
    } else {
      this.props.showDialog({
        isOpen: true,
        title: "Data Download",
        content: "This item has no download information yet.",
        onDialogOk: () => {},
      });
    }
  }

  onInfoClick() {
    //TODO: info from metaData
    this.props.showDialog({
      isOpen: true,
      title: "Additional Information",
      content: `${this.props.layerItem.metaData.info ||
        "No additional information is provided for this item yet."}`,
      onDialogOk: () => {},
    });
  }

  openVoxelViewer() {
    let url = "/voxel_viewer/?";
    url += "voxel_id=" + this.props.layerItem.id;
    if (true) {
      // if ( this.$config.useEsriProxy) {
      let auth_info = {
        token: GetArcGISToken.token,
        baseUrl: this.$config.baseUrl,
        esriProxy: this.$config.esriProxyUrl,
      };
      url =
        this.$config.baseUrl +
        url +
        "&auth_info=" +
        btoa(JSON.stringify(auth_info));
    }
    window.open(url);
  }

  render() {
    let token = GetArcGISToken.token;
    // let encodedToken = encodeURIComponent(token)

    // let thumbnailUrl = `${this.$config.portalUrl}/sharing/rest/content/items/${this.props.layerItem.id}/info/${
    //   this.props.layerItem.thumbnail
    // }?token=${token}`;

    let thumbnailUrl = !!this.props.layerItem.thumbnail
      ? `${this.$config.portalUrl}/sharing/rest/content/items/${
          this.props.layerItem.id
        }/info/${this.props.layerItem.thumbnail}?token=${token}`
      : `${
          this.$config.portalUrl
        }/home/js/arcgisonline/css/images/default_thumb.png`;

    let { layerItem } = this.props;

    let layerObj = "layer" in layerItem ? layerItem.layer : undefined;
    let dateInMetadata = this.props.layerItem.metaData?.dateOfCapturing;
    let displayCreatedDate = moment(
      dateInMetadata || this.props.layerItem.createDate,
      "D/M/YYYY"
    ).format("D MMM, YYYY");

    return (
      <div className="layer3DItemContainer">
        <div>
          <div className="layer3DItemToolkits">
            <div className="layer3DItemCheckbox">
              <Checkbox
                checked={"layer" in layerItem && !!layerItem?.layer?.visible}
                onClick={this.onCheckboxClick.bind(this)}
                color="primary"
              />
            </div>
          </div>

          <div className="layer3DItemThumbnail">
            <img
              referrerPolicy="no-referrer"
              src={thumbnailUrl}
              title="Click to zoom to the location"
              onClick={() => {
                this.props.mapView.extent = this.props.layerItem.extent;
              }}
            />
          </div>

          <div className="layer3DItemTextContainer">
            <div className="layer3DItemCategory">{this.props.categry}</div>
            <div className="layer3DItemTitle">{this.props.layerItem.title}</div>
          </div>
          <div className="EqualWidthChildren layer3DItemMenuBar">
            <div>
              <span className="layer3DItemCreatedDate">
                {displayCreatedDate}
              </span>
            </div>
            <div className="AlignRight">
              <Button onClick={this.handleClickThreePoints.bind(this)}>
                <MoreVertIcon />
              </Button>
            </div>
          </div>

          {this.state.showOperationBox && (
            <div
              onMouseLeave={this.onLeaveOperationContainer.bind(this)}
              className="layer3DItemOperationContainer"
            >
              <div className="layer3DOpacitySlider">
                {layerItem.type in LAYER_TYPE_OPACITY_SUPPORT &&
                  "layer" in layerItem &&
                  !!layerItem?.layer?.visible && (
                    <OpacitySlider
                      darkMode={true}
                      layer={
                        layerItem.type in LAYER_TYPE_OPACITY_SUPPORT
                          ? layerItem.layer
                          : undefined
                      }
                    />
                  )}
              </div>
              <div className="layer3DInfoAndDownload">
                {layerItem.type === "voxel" && (
                  <Button
                    className="VoxelViewerButton"
                    onClick={() => this.openVoxelViewer()}
                  >
                    <span
                      className="icn_3d_Elevationprofile_export"
                      style={{ filter: "brightness(300%) invert(1)" }}
                    />
                    <span>&nbsp;</span>
                    <span>Voxel Viewer</span>
                  </Button>
                )}
                <Button onClick={this.onInfoClick.bind(this)}>
                  <span
                    className="icn_black_24dp"
                    style={{ filter: "brightness(300%) invert(1)" }}
                  />
                  <span>&nbsp;</span>
                  <span>Info</span>
                </Button>
                {layerItem.type in DOWNLOAD_SUPPORT && (
                  <Button onClick={this.onDownloadClick.bind(this)}>
                    <span
                      className="icn_download"
                      style={{ filter: "brightness(300%) invert(1)" }}
                    />
                    <span>&nbsp;</span>
                    <span>Download</span>
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ItemCard;
